<nz-modal [(nzVisible)]="isVisible" [nzTitle]="modalTitle" [nzContent]="modalContent" [nzFooter]="modalFooter"
  (nzOnCancel)="closeDialogue()" (nzOnOk)="closeDialogue()" nzBlockNode nzWidth="75%">
  <ng-template #modalTitle>
    Container Route 
  </ng-template>

  <ng-template #modalContent>
    <ng-container>
      <div>
        <div nz-row class="listStyle">
          <h3>Legends:</h3>
        </div>
        <div nz-row class="listStyle">
         <label> Followed Path : <nz-tag [nzColor]="'#f50'"></nz-tag></label><br>
         <label> Shortest Path : <nz-tag [nzColor]="'#87d068'"></nz-tag></label>
         
        </div>
      </div>

      <div class="mx-auto">
      <google-map height="400px" width="750px" [center]="center" [zoom]="zoom">
        <map-polyline [path]="shortestPathArray" [options]="shortestPathOptions"></map-polyline>
        <map-polyline [path]="followedPathArray" [options]="followedPathOptions"></map-polyline>
      </google-map>
      </div>
    </ng-container>

  </ng-template>
  <ng-template #modalFooter>
    <button nz-button nzType="primary" (click)="closeDialogue()">Close</button>
  </ng-template>
</nz-modal>